// extracted by mini-css-extract-plugin
module.exports = {"contents":"SliderContents_contents__3sed8","divider":"SliderContents_divider__3iyC0"};